import * as React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { GetProductsModel } from "../models/store.model";
import { useHistory } from "react-router-dom";
import { PRODUCT_KEY } from "../../config/cacheKey";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
interface props {
  product: GetProductsModel;
}
export default function ProductCard({ product }: props) {
  const history = useHistory<{
    key: string;
  }>();
  const handleDetail = () => {
    sessionStorage.setItem(PRODUCT_KEY, product.key);
    history.push({
      pathname: "/products/productCategory1/productList1/ProductDetail",
      state: {
        key: product.key,
      },
    });
  };
  return (
    <Box sx={{ width: "100%", padding: "20px" }}>
      <Grid
        container
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        onClick={handleDetail}
        className="cursorPointer"
      >
        <Grid
          item
          xs={12}
          style={{
            border: "1px solid #E0E0E0",
            textAlign: "center",
            padding: "20px ",
            borderRadius: "6px",
          }}
        >
          {product.imageData ? (
            <img
              src={`data:image/png;base64,${product.imageData}`}
              style={{ objectFit: "contain", width: "100%", height: "100%" }}
            />
          ) : (
            <img
              src="images/notfound.png"
              style={{ objectFit: "contain", width: "80%", height: "80%" }}
            />
          )}
        </Grid>

        <Grid
          item
          xs={12}
          container
          style={{ textAlign: "justify", margin: "10px 0" }}
        >
          <Grid
            item
            xs={12}
            style={{ marginBottom: "10px", fontSize: "1em", minHeight: "6vh" }}
            className="fontMedium"
          >
            <b>{product.title}</b>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              color: "#F06292",
              marginBottom: "10px",
              fontSize: ".8em",
              fontWeight: "bold",
            }}
          >
            <b>مهلت خرید تا {product.expirationDate_Persian}</b>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{ color: "#64B5F6", fontSize: ".8em", fontWeight: "bold" }}
          >
            <b>موجودی {product.count} عدد</b>
          </Grid>{" "}
          <Grid
            item
            xs={12}
            sm={12}
            md={6}
            lg={6}
            style={{ textAlign: "left", fontSize: "1.2em" }}
          >
            <b>{product?.unitPrice.toLocaleString()}</b> ریال
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
